import axios from 'axios'
import { errorHandler } from '../exports/error_management'

const api = async (method, path, params) => axios[method](path, params)

import { StorageCache } from '../exports/dataStorage'

const storageKey = 'ams-additional-field-key'

const state = {
    additional_field: null,
    additional_fields: [],
}

const mutations = {
    set_additional_field(state, payload) {
        state.additional_field = payload
    },

    set_additional_fields(state, payload) {
        state.additional_fields = payload
    },
}

const actions = {
    async create(context, payload) {
        const storageCache = new StorageCache(storageKey)
        try {
            storageCache.reset()
            const results = await api('post', `additional-field`, payload)
            context.commit('set_additional_field', results.data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },
    async createAdditionalFieldItem(context, payload) {
        const storageCache = new StorageCache(storageKey)
        try {
            storageCache.reset()
            const results = await api(
                'post',
                `additional-field/create-field-item`,
                payload
            )
            context.commit('set_additional_field', results.data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },

    async fetchById(context, id) {
        try {
            const results = await api('get', `additional-field/${id}`)
            context.commit('set_additional_field', results.data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },

    async fetchAll(context, payload) {
        // const storageCache = new StorageCache(storageKey)
        try {
            var module_for = (payload && payload.module_for) || 1
            console.log('moduleFor', module_for)
            const results = await api('get', `additional-field/${module_for}`)
            const data = results.data.success.data
            context.commit('set_additional_fields', data)
            // const { is_valid, value } = storageCache.getArray()
            // if (!is_valid) {
            //     var module_for = (payload && payload.module_for) || 1
            //     console.log('moduleFor', module_for)
            //     const results = await api(
            //         'get',
            //         `additional-field/${module_for}`
            //     )
            //     const data = results.data.success.data
            //     storageCache.set(data)
            //     value.splice(0)
            //     value.push(...data)
            // }
            // context.commit('set_additional_fields', value)
        } catch (err) {
            errorHandler(err)
        }
    },
    async updateAdditionalFieldItemOrder(context, payload) {
        const storageCache = new StorageCache(storageKey)
        try {
            storageCache.reset()
            await api('post', `additional-field/update/display/order/`, payload)
            // context.dispatch('fetchAll')
        } catch (err) {
            errorHandler(err)
        }
    },
    async update(context, payload) {
        console.log('update', payload)
        const storageCache = new StorageCache(storageKey)
        try {
            storageCache.reset()
            const results = await api(
                'put',
                `additional-field/${payload.id}`,
                payload
            )
            context.commit('set_additional_field', results.data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },
    async updateAdditionalFieldItem(context, payload) {
        const storageCache = new StorageCache(storageKey)
        console.log('update', payload)
        try {
            storageCache.reset()
            const results = await api(
                'put',
                `additional-field/update-field-item/${payload.id}`,
                payload
            )
            context.commit('set_additional_field', results.data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },

    async delete(context, id) {
        const storageCache = new StorageCache(storageKey)
        try {
            storageCache.reset()
            await api('delete', `additional-field/delete-field-item/${id}`)
            context.commit('set_additional_fields', null)
            // context.dispatch('fetchAll')
        } catch (err) {
            errorHandler(err)
        }
    },
}

const getters = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
